import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $VatPrefixesModuleName } from "./vatPrefixes.types";

const { actions } = CreateApiModule(
    $VatPrefixesModuleName,
    () => `/i18nservice/${Config.general.basestore}/i18n/vatprefixes`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
